import axios from "axios";
import { API_BASE_URL } from "./api";

// Instância isolada do candidato — usa um token próprio (candToken) e NÃO compartilha
// o interceptor de 401→/login do staff (o portal trata a sessão localmente).
export const apiCand = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

export const CAND_TOKEN_KEY = "candToken";
export const CAND_USER_KEY = "candUser";

apiCand.interceptors.request.use((config) => {
  try {
    const t = localStorage.getItem(CAND_TOKEN_KEY);
    if (t && !config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  } catch (_) {}
  return config;
});

// Sessão expirada/ inválida (401): limpa a sessão do candidato e recarrega o
// portal, que volta a exibir as abas de cadastro/login (sem modal de erro).
apiCand.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && localStorage.getItem(CAND_TOKEN_KEY)) {
      localStorage.removeItem(CAND_TOKEN_KEY);
      localStorage.removeItem(CAND_USER_KEY);
      window.location.reload();
    }
    return Promise.reject(err);
  }
);
